import { render, staticRenderFns } from "./ship_info.vue?vue&type=template&id=9576141c&scoped=true"
import script from "./ship_info.vue?vue&type=script&lang=js"
export * from "./ship_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9576141c",
  null
  
)

export default component.exports